// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1U40w","withMobileMargins":"DateRangeInput_withMobileMargins__2wkiu","arrowIcon":"DateRangeInput_arrowIcon__1tQX6"};